import { Button, Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

// Components
import CreateAssessment from "../CreateAssessment";
import RadioQuestionView from "./RadioQuestionView";
import { APIs } from "../../../constants/api.constants";
import CheckboxQuestionView from "./CheckboxQuestionView";
import ParagraphQuestionView from "./ParagraphQuestionView";
import { ApiService, getRequest } from "../../../services/ApiService";

const EpisodeAssessmentModal = ({ props }) => {
  const { assessmentId, toggleAssessmentPopup, assessmentPopupIsOpen } = props;
  const [loader, setLoader] = useState(false);
  const [create, setCreate] = useState(false);
  const [assessmentData, setAssessmentData] = useState({});
  const [confirmCreate, setConfirmCreate] = useState(false);

  const createAssessmentHandler = () => {
    if (confirmCreate) {
      setConfirmCreate(false);
      setCreate(true);
    } else {
      if (assessmentData.length !== 0) {
        setConfirmCreate(true);
      } else {
        setCreate(true);
      }
    }
  };

  const deleteAssessmentHandler = () => {
    ApiService.deleteRequest(
      APIs.assessment + "/hard-delete/" + assessmentData.id
    ).then(
      () => {
        const params = `?episode_id=${assessmentId}`;
        getRequest(APIs.getQuestionsByEpisode + params).then((res) =>
          setAssessmentData(res.data)
        );
      },
      (error) => {
        notification["error"]({ message: error.message });
      }
    );
  };

  const removeCreateForm = () => {
    setCreate(false);
  };

  const showQuestions = (item) => {
    switch (item.question_type) {
      case "multiple_choice":
        return <RadioQuestionView question={item} />;
      case "multiple_selection":
        return <CheckboxQuestionView question={item} />;
      case "text":
        return <ParagraphQuestionView question={item} />;
      default:
        return;
    }
  };

  useEffect(() => {
    if (!assessmentPopupIsOpen) {
      setCreate(false);
    }
  }, [assessmentPopupIsOpen]);
  
  useEffect(() => {
    if (assessmentPopupIsOpen && assessmentId) {
      const params = `?episode_id=${assessmentId}`;
      getRequest(APIs.getQuestionsByEpisode + params).then((res) =>
        setAssessmentData(res.data)
      );
    }
  }, [assessmentPopupIsOpen, assessmentId]);

  return (
    <>
      <Modal
        title="View Assessment"
        onOk={toggleAssessmentPopup}
        visible={assessmentPopupIsOpen}
        onCancel={toggleAssessmentPopup}
        footer={
          create
            ? []
            : [
                <Button type="secondary" onClick={toggleAssessmentPopup}>
                  Close
                </Button>,
              ]
        }
      >
        {!create && (
          <div className="d-flex justify-content-start mb-4">
            <div className="d-flex pr-1">
              <Button type="primary" onClick={createAssessmentHandler}>
                Create Assessment
              </Button>
            </div>
            {assessmentData ? (
              <div className="d-flex">
                <Button type="primary" onClick={deleteAssessmentHandler}>
                  Delete
                </Button>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}

        {create ? (
          <CreateAssessment
            episodeId={assessmentId}
            closeModal={toggleAssessmentPopup}
            removeCreateForm={removeCreateForm}
          />
        ) : loader ? (
          <div className="d-flex align-items-center justify-content-center">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 60 }} spin />}
            />
          </div>
        ) : assessmentData.length === 0 ? (
          <p className="text-center">No assessment assigned to this episode</p>
        ) : (
          assessmentData?.assessment_question?.map((item) => {
            return showQuestions(item);
          })
        )}
      </Modal>

      <Modal
        title="Confirm Replace Assessment"
        visible={confirmCreate}
        onOk={createAssessmentHandler}
        onCancel={() => setConfirmCreate(false)}
        okText="Confirm"
        cancelText="Cancel"
        width={350}
      >
        You already have an assessment assigned to this episode. Please confirm
        if you want to replace this.
      </Modal>
    </>
  );
};

export default EpisodeAssessmentModal;
